import React from 'react'
import { Box, Grid, Typography, useTheme } from '@mui/material'

const steps = [
  { number: 1, label: 'Experience' },
  { number: 2, label: 'Opportunities' },
  { number: 3, label: 'Get Matched' },
]

export default function StepsBanner() {
  const theme = useTheme()

  return (
    <Box
      component="section"
      sx={{
        borderBottom: '1px solid',
        boxShadow: '-2px -1px 4px 1px rgba(0, 0, 0, 0.1)',
        borderColor: 'divider',
        py: 3,
        mb: '50px',
        bgcolor: 'background.paper',
      }}
    >
      <Grid container justifyContent="center" spacing={{ xxs: 4, xs: 8 }}>
        {steps.map((step) => (
          <Grid item key={step.number} xs="auto">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  bgcolor: theme.palette.primary.main,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '1rem',
                }}
              >
                {step.number}
              </Box>
              <Typography
                variant="subtitle2"
                sx={{
                  mt: 1,
                  color: 'rgb(46, 59, 86)',
                  fontWeight: 400,
                  fontSize: { xxs: '12px', sm: '14px' },
                }}
              >
                {step.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}